import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import { withTranslation } from 'react-i18next';
import { avatarUrl, formatDate } from '../../utils/Formatters';
import AccountPlayerDetails from './AccountPlayerDetails';
import AccountPlayerPlaysSummary from './AccountPlayerPlaysSummary';
import AccountPlayerStats from './AccountPlayerStats';
import { appNamedRoutes, linkWithParams } from '../../routes';
import { isAdminDashboard, isEditable, isASQEnabled, isChatEnabled, canAddCompletedASQ, isTeacher } from '../../utils/authScopes';
import { Link } from 'react-router-dom';
import qrstr from 'query-string';

class AccountPlayer extends React.Component {
  static propTypes = {
    accountPlayer: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    backLink: PropTypes.object.isRequired,
    cohorts: PropTypes.arrayOf(PropTypes.object).isRequired,
    tabIdx: PropTypes.number.isRequired,
    onClickMore: PropTypes.func.isRequired,
    onGoBack: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onResetCohorts: PropTypes.func.isRequired,
    onAddCompletedASQ: PropTypes.func,
  };

  render() {
    const { t, auth, accountPlayer, backLink, cohorts, tabIdx, onClickMore, onGoBack, onUpdate, onResetCohorts, onAddCompletedASQ } = this.props;

    if (isEmpty(accountPlayer)) return null;
    if (get(accountPlayer, 'deleted')) { onGoBack(backLink); return null; }
    const bg = { backgroundImage: avatarUrl(accountPlayer) };
    const editable = isEditable(auth);
    const engagement = [accountPlayer.stats.plays.total, accountPlayer.stats.plays.range];
    const interactivity = [accountPlayer.stats.uploads.total, accountPlayer.stats.uploads.range];
    const asqs = accountPlayer.currentAsq;
    let isNotEmpty = false;
    let asq;
    if (asqs !== 'undefined' && asqs.length > 0) {
      isNotEmpty = true
    }
    return (
      <div className='column small-12 medium-3'>
        <div className='u-flex u-margin-bottom--base'>
          <div style={bg} className='o-avatar o-avatar--base u-margin-right--base'></div>
          <div>
            <div className='flex-container'>
              <div>
                <span className='u-txt--header'>{accountPlayer.firstName}</span><br />
                <span className='u-txt--header'>{accountPlayer.lastName}</span>
              </div>
              {isChatEnabled(auth) &&
                <div className='padding-left-1'>
                  <Link className='cs-txt-link--sp-blue'
                    to={{
                      pathname: appNamedRoutes.communicationIndividuals,
                      search: `?id=${accountPlayer.id}`
                    }}
                    title={t('player.coaching')}>
                    <i className='fa fa-comments-o'></i>
                  </Link>
                </div>}
            </div>
            <br />
            <span className='u-txt--label'>{t('accountPlayer.age')}</span><br />
            <span><b>{accountPlayer.formattedAge}</b></span><br />
            {isASQEnabled(auth) && isNotEmpty ?
              <span>
                <Link className='cs-txt-link--sp-blue' to={{ pathname: linkWithParams('asqs'), search: qrstr.stringify({ player: accountPlayer.id }) }}>
                  {t('accountPlayer.asqSurveys')}
                </Link>
              </span> : ''}
          </div>
        </div>
        <div className='o-card__wrap'>
          <AccountPlayerDetails accountPlayer={accountPlayer} cohorts={cohorts} onUpdate={onUpdate} onResetCohorts={onResetCohorts} editable={editable} />
        </div>
        {canAddCompletedASQ(auth) && !isTeacher(auth) && onAddCompletedASQ && (
          <button
            className='o-sp-button o-sp-button--base o-sp-button--secondary u-margin-bottom--base'
            style={{ width: '100%' }}
            onClick={onAddCompletedASQ}
          >
            {t('player.addCompletedASQ')}
          </button>
        )}
        <AccountPlayerStats title={t('dashboard.engagement')} data={engagement.slice(0, 1)} />
        <AccountPlayerStats title={t('dashboard.interactivity')} data={interactivity.slice(0, 1)} />
        <AccountPlayerPlaysSummary plays={accountPlayer.plays} tabIdx={tabIdx} onClickMore={onClickMore} />
        <div className='o-card__wrap'>
          <section className='column o-card cs-bg--light'>
            {isAdminDashboard(auth) &&
              <p className='u-margin-bottom--tiny'>
                <span className='u-txt--label'>{t('accountPlayer.partner')}</span><br />
                {accountPlayer.partner}
              </p>}
            <p className='u-margin-bottom--tiny'>
              <span className='u-txt--label'>{t('accountPlayer.applicationLocale')}</span><br />
              {accountPlayer.locale}
            </p>
            <p className='u-margin-bottom--tiny'>
              <span className='u-txt--label'>{t('accountPlayer.lastAppTouch')}</span><br />
              {formatDate(accountPlayer.lastAppTouch)}
            </p>
          </section>
        </div>
      </div>
    );
  }
}

export default withTranslation()(AccountPlayer);
